import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { LANGUAGES } from "./contants";

export const i18nConfig = {
  langs: Object.keys(LANGUAGES),
  defaultLang: "en",
};

// flags svg can be downloaded from https://github.com/ekwonye-richard/react-flags-select/tree/master/flags
// flags emojis can be copied from https://emojipedia.org/flags/
export const i18nFlags = Object.entries(LANGUAGES).reduce(
  (acc, [key, { flag }]) => {
    acc[key] = flag;
    return acc;
  },
  {}
);

// eslint-disable-next-line import/no-named-as-default-member
export default i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      cz: {
        common: require("./localization/cz/common.json"),
      },
      dk: {
        common: require("./localization/dk/common.json"),
      },
      de: {
        common: require("./localization/de/common.json"),
      },
      en: {
        common: require("./localization/en/common.json"),
      },
      es: {
        common: require("./localization/es/common.json"),
      },
      fi: {
        common: require("./localization/fi/common.json"),
      },
      fr: {
        common: require("./localization/fr/common.json"),
      },
      hu: {
        common: require("./localization/hu/common.json"),
      },
      it: {
        common: require("./localization/it/common.json"),
      },
      jp: {
        common: require("./localization/jp/common.json"),
      },
      nl: {
        common: require("./localization/nl/common.json"),
      },
      no: {
        common: require("./localization/no/common.json"),
      },
      pl: {
        common: require("./localization/pl/common.json"),
      },
      pt: {
        common: require("./localization/pt/common.json"),
      },
      sw: {
        common: require("./localization/sw/common.json"),
      },
    },
    fallbackLng: i18nConfig.defaultLang,
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
